/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import useApiClient from "../useApiClient";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useHotelContext } from "./useHotelContext";
import { toast } from "react-toastify";
import useMimir from "hooks/useMimir";
import { pixelEvent } from "helpers/common";


const useHotelConfirmation = () => {   
    const navigate = useNavigate()
    const {api , urls} = useApiClient()
    const { i18n,t } = useTranslation()
    const [loading , setLoading] = useState(false)
    const { guestsInformation ,hotelSelection } = useHotelContext()
    const [ showRequestBooking , setShowRequestBooking ] = useState(false)
    const { mimir } = useMimir()

    useEffect(() => {
      if(!hotelSelection || !guestsInformation){
        navigate("/hotel-search")
      }
    },[])

    const buildMimirPayload = (payload, result) => {
        return {
            type: "HOTEL",
            event: "CONFIRMATION",
            param1: JSON.stringify(payload || {}),
            param2: JSON.stringify(result || {}),
        };
    };

    const confirmBooking = async ( paymentMethod, captchaToken ) => {
        let result; 
        const payload = createConfirmationPayload(hotelSelection, guestsInformation);
        pixelEvent(payload["total_price"], "DZD");
        payload["language"] = i18n.language;
        payload["fop"] = paymentMethod;
        if(captchaToken){
            payload["recaptchaToken"] = captchaToken;
        }
        if (!payload) return;
        try {
          setLoading(true);
          const res = await api.post(urls.hotel.confirmation, JSON.stringify(payload));
          result = res?.data;
          if(paymentMethod  === "DELIVERY"){
            if(res.data.success && res.data["result"] && !res.data["result"]["IBE_Errors"]){
              console.log('success');
              setShowRequestBooking(true)
            }else{
              console.log('error');
              toast.error(t("deliveryError"));
            }
          }
          
        } catch (error) {
            console.error("Error confirming booking:", error);
            toast.error(t("deliveryError"))
        } finally {
          setLoading(false);
          mimir.log(buildMimirPayload(payload, result));
        }
      };

    const  createConfirmationPayload = (hotelSelection , guestsInformation) => {
        const payload  = {}
        const hotelState  = JSON.parse(localStorage.getItem("hotelState") || "{}")
        if(!hotelSelection || !guestsInformation || !hotelState) return null
        payload["checkInDate"] = hotelState?.checkInDate
        payload["checkOutDate"] = hotelState?.checkOutDate
        payload["hotelName"] = hotelSelection?.selectedHotel?.name
        payload["hotelCode"] = hotelSelection?.selectedHotel?.code
        hotelSelection?.selectedHotel?.hotelCodeCrypted  && 
        (payload["hotelCodeCrypted"] = hotelSelection?.selectedHotel?.hotelCodeCrypted)
        payload["Comment"] = "" //TODO
        payload["provider"] = hotelSelection?.selectedHotel?.provider
        payload["provider_id"] = hotelSelection?.selectedHotel?.provider_id
        payload["trace"] = true
        payload["customer_address"] = guestsInformation?.customerAddress
        payload["customer_city"] = "Adrar" //TODO
        payload["customer_country"] = guestsInformation?.customerCountry?.value || "Algeria"
        payload["customer_email"] = guestsInformation?.email
        payload["customer_phoneNumber"] = guestsInformation?.customerMobileNo
        payload["customer_phone_countrycode"] = guestsInformation?.customerCountry?.id+""
        payload["remark"] = '' //TODO
        payload["booking_remark"] = '' //TODO
        payload["room"] = hotelState?.rooms?.length
        payload["total_price"] = hotelSelection?.totalPrice
        payload["point_of_sale_id"] = null;
        for ( let i=1; i <= hotelState?.rooms?.length; i++ ){
            payload[`adults_${i}`] = hotelState?.rooms[i-1]?.adults
            payload[`children_${i}`] = hotelState?.rooms[i-1]?.children
            payload[`remark_room_${i}`] = "" //TODO
    
            for ( let j=1; j<= hotelState?.rooms[i-1].adults ;j++ ){
                payload[`firstname_${i}_${j}`] =  guestsInformation[`firstNameADT${i}${j}`]
                payload[`lastname_${i}_${j}`] =  guestsInformation[`lastNameADT${i}${j}`]
                payload[`gender_${i}_${j}`] =  ["السيد","Mr","Monsieur"].includes(guestsInformation[`titleADT${i}${j}`]?.value)  ? "M" : "F"
                payload[`type_${i}_${j}`] = "ADT"
            }
    
            for ( let j=1; j<= hotelState?.rooms[i-1].children ;j++ ){
                payload[`firstname_${i}_${j}`] =  guestsInformation[`firstNameCHD${i}${j}`]
                payload[`lastname_${i}_${j}`] =  guestsInformation[`lastNameCHD${i}${j}`]
                payload[`gender_${i}_${j}`] =  ["السيد","Mr","Monsieur"].includes(guestsInformation[`titleADT${i}${j}`]?.value)  ? "M" : "F"
                payload[`type_${i}_${j}`] = "CHD"
                payload[`age_${i}_${j}`] =  guestsInformation[`ageCHD${i}${j}`]
            }                                       
        }
        hotelSelection?.seletedRates?.forEach((rate,index)=>{
            payload[`rateKey_${index+1}`] = rate.rateKey
            payload[`boarding_name_${index+1}`] = rate.pension
            payload[`room_name_${index+1}`] = rate.name
            payload[`supp_${index+1}`] = 0  //TODO
    
            // TODO
            // this.hotelService.supplementsArray
            //     .filter((el) => el.rateIndex === rateIndex)
            //     .forEach(function (supp, index) {
            //         confirmationRequest["supp_" + rateIndex + "_" + (index + 1)] =
            //             supp["supplement"]["SuppID"] +
            //             "@" +
            //             supp["supplement"]["SuppChargeType"] +
            //             "@" +
            //             supp["supplement"]["Price"];
            //     });
        })
        return payload;
    }
    
    return {
        confirmBooking,
        loading,
        showRequestBooking
    };
}
export default useHotelConfirmation;